<template>
    <nav aria-label="Breadcrumb"
         class="flex"
    >
        <ol class="flex items-start lg:items-center gap-4 flex-wrap text-gray-600"
            role="list"
        >
            <li>
                <div>
                    <Link :href="route('home')"
                          class="hover:text-gray-700"
                    >
                        <HomeIcon aria-hidden="true"
                                  class="h-5 w-5 shrink-0"
                        />

                        <span class="sr-only">Home</span>
                    </Link>
                </div>
            </li>

            <li v-for="(page, index) in $props.breadcrumbs"
                :key="page.name"
            >
                <div class="flex items-center">
                    <ChevronRightIcon aria-hidden="true"
                                      class="h-5 w-5 shrink-0"
                    />

                    <Link :aria-current="index === ($props.breadcrumbs.length - 1) ? 'page' : undefined"
                          :href="page.href"
                          class="ml-4 text-sm font-medium hover:text-gray-700"
                    >{{ page.name }}
                    </Link>
                </div>
            </li>
        </ol>
    </nav>
</template>

<script setup>
import {
    ChevronRightIcon,
    HomeIcon,
}             from '@heroicons/vue/20/solid';
import {Link} from '@inertiajs/vue3';
</script>

<script>
export default {
    props: {
        breadcrumbs: Array,
    },
};
</script>